export default {
  getResApplication: {
    method: 'get',
    url: '/v1/basic/applications/res',
    mockData: {
      code: 200,
      data: [],
      message: '成功'
    }
  },
  getScreenMenus: {
    method: 'get',
    url: '/v1/service/screenMenus',
    mockData: {
      code: 200,
      data: [],
      message: '成功'
    }
  },
  getMenus: {
    method: 'get',
    url: '/v1/service/screens',
    mockData: {
      code: 200,
      data: [],
      message: '成功'
    }
  },
  getView: {
    method: 'get',
    url: '/v1/service/views',
    mockData: {
      code: 200,
      data: [],
      message: '成功'
    }
  },
  getCustomizeApplet: {
    method: 'get',
    url: '/v1/basic/customize/applets',
    mockData: {
      code: 200,
      data: [],
      message: '成功'
    }
  },
  getAppletConfig: {
    method: 'get',
    url: '/v1/service/applet/configs',
    mockData: {
      code: 200,
      data: [],
      message: '成功'
    }
  },
  getListData: {
    method: 'post',
    url: '/v1/service/applet/list',
    mockData: {
      code: 200,
      data: [],
      message: '成功'
    }
  },
  getDetailData: {
    method: 'get',
    url: '/v1/service/applet/detail',
    mockData: {
      code: 200,
      data: [],
      message: '成功'
    }
  },
  putAppletData: {
    method: 'put',
    url: '/v1/service/applet/data',
    mockData: {
      code: 200,
      data: [],
      message: '成功'
    }
  },
  getReport: {
    method: 'get',
    url: '/v1/service/report',
    mockData: {
      code: 200,
      data: [],
      message: '成功'
    }
  },
  deleteAppletData: {
    method: 'delete',
    url: '/v1/service/applet/data',
    mockData: {
      code: 200,
      data: [],
      message: '成功'
    }
  }
}
